module.exports = __webpack_public_path__ + "img/gr.9823f616.svg";